import { NavItem } from '@billy/design-system'
import { TFunction } from 'i18next'

import { PeriodComparisonValue } from '../../../types/periodComparisonValue'
import { isSupportedMode } from './isSupportedMode'

export const getItems = (maxPeriods: number, mode: PeriodComparisonValue, t: TFunction): NavItem<number>[] => {
  if (!isSupportedMode(mode)) {
    return []
  }

  const periodWordMap = {
    year: { singular: t('reports.year'), plural: t('reports.years') },
    period: { singular: t('reports.period'), plural: t('reports.periods') },
    month: { singular: t('reports.month'), plural: t('reports.months') },
    quarter: { singular: t('reports.quarter'), plural: t('reports.quarters') },
  }

  const { singular, plural } = periodWordMap[mode]

  const items: NavItem<number>[] = [
    {
      id: '0',
      children: t('reports.none'),
      value: 0,
    },
  ]

  for (let i = 1; i <= maxPeriods; i++) {
    const label = i === 1 ? singular : plural
    items.push({
      id: i.toString(),
      children: `${i} ${label}`,
      value: i,
    })
  }

  return items
}
